module.exports = __webpack_public_path__ + "static/media/18ECA28.54023326.jpg";